import React, {useEffect, useRef, useState} from "react";
import {ELEMENT_PICKER_TYPES, FIREBASE_SCREEN_NAMES, LOCALSTORAGE_ITEMS} from "../../util/Constants";
import * as StorageService from "../../services/StorageService";
import {FormattedMessage} from "react-intl";
import iconPhone from "../../assets/img/icon_phone.svg";
import iconLocation from "../../assets/img/icon_location.svg";
import ElementPicker from "../../components/ElementPicker";
import backImg from "../../assets/img/icon_back.svg";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import ReservationActionsBar from "../../components/Actionsbar/ReservationActionsBar";
import * as ReservationService from "../../services/ReservationService";
import Moment from "react-moment";
import {DATE_FORMAT} from "../../util/DateUtil";
import {getAppLocale, resetTime} from "../../util/common";
import Spinner from "../../components/Spinner";
import {PATH} from "../../routes/routes.js";
import CookiesBanner from "../../components/Banner/CookiesBanner";
import analyticsLogEvent from "../../services/FirebaseService";

import iconSchedule from "../../assets/img/icon_schedule.svg";
import {useNavigate} from "react-router";

function CreateReservation() {

    const navigateTo = useNavigate();
    const DAY = {
        TODAY: "TODAY",
        TOMORROW: "TOMORROW",
        MORE_DATES: "MORE_DATES"
    }

    const hasBackButton = StorageService.getItem(LOCALSTORAGE_ITEMS.HAS_BACK_BUTTON) === "true";

    const hasReservations = StorageService.getItem(LOCALSTORAGE_ITEMS.HAS_RESERVATIONS) === "true";
    const userType = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) ? StorageService.getItem(LOCALSTORAGE_ITEMS.USER_TYPE) : null;
    const userInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.USER_INFO)) : null;
    const reservationInfo = StorageService.getItem(LOCALSTORAGE_ITEMS.RESERVATION_INFO) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.RESERVATION_INFO)) : null;
    const shopDetails = StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS) ? JSON.parse(StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_DETAILS)) : null;
    const reservationEnabled = shopDetails?.merchantConfig?.reservation;

    const today = new Date();

    const tomorrow = resetTime(new Date());
    tomorrow.setDate(tomorrow.getDate() + 1);

    const afterTwoDays = resetTime(new Date());
    afterTwoDays.setDate(afterTwoDays.getDate() + 2);

    const nextYear = new Date(new Date().setFullYear(new Date().getFullYear() + 1));

    const todayRef = useRef(null);
    const tomorrowRef = useRef(null);
    const moreDatesRef = useRef(null);

    const todayIndex = new Date().getDay() === 0 ? 6 : new Date().getDay() - 1;
    const tomorrowIndex = todayIndex === 6 ? 0 : todayIndex + 1;

    const weekReservationSchedule = shopDetails?.merchantConfig?.weekReservationSchedule?.schedule || null;
    const todayReservationSchedule = weekReservationSchedule ? weekReservationSchedule[todayIndex] : null;
    const tomorrowReservationSchedule = weekReservationSchedule ? weekReservationSchedule[tomorrowIndex]: null;


    const getAvailableHoursForReservation = (chosenDay) => {
        if (!shopDetails?.merchantConfig?.weekReservationSchedule?.schedule ||
            shopDetails.merchantConfig.weekReservationSchedule.schedule.length === 0) {
            return [];
        }

        const dayOfWeek = chosenDay.getDay() === 0 ? 6 : chosenDay.getDay() - 1;

        const daySchedule = shopDetails.merchantConfig.weekReservationSchedule.schedule[dayOfWeek];

        if (!daySchedule?.isOpen || !daySchedule.daySchedule.length) return [];

        const intervalMinutes = 15;
        const availableHours = [];

        const now = new Date();
        const isToday = now.getFullYear() === chosenDay.getFullYear() &&
            now.getMonth() === chosenDay.getMonth() &&
            now.getDate() === chosenDay.getDate();

        const currentHour = now.getHours();
        const currentMinutes = now.getMinutes();

        function addHours(fromHours, fromMinutes, toHours, toMinutes) {
            let hours = fromHours;
            let minutes = fromMinutes;

            if (isToday && (hours < currentHour || (hours === currentHour && minutes < currentMinutes))) {
                hours = currentHour;
                minutes = Math.ceil(currentMinutes / intervalMinutes) * intervalMinutes;
                if (minutes >= 60) {
                    minutes = 0;
                    hours++;
                }
            }

            while (hours < toHours || (hours === toHours && minutes < toMinutes)) {
                const realToHours = hours % 24;
                availableHours.push(`${realToHours < 10 ? "0" + realToHours : realToHours}:${minutes < 10 ? "0" + minutes : minutes}`);
                minutes += intervalMinutes;
                if (minutes >= 60) {
                    minutes -= 60;
                    hours++;
                }
            }
        }

        for (const interval of daySchedule.daySchedule) {
            const [fromHours, fromMinutes] = interval.openFrom.split(":").map(Number);
            const [toHours, toMinutes] = interval.openUntil.split(":").map(Number);

            if (fromHours === 0 && toHours === 0) {
                // 00:00 - 00:00
                addHours(0, 0, 24, 0);
            } else if (toHours < fromHours) {
                // Overnight (e.g., 09:00 - 02:00)
                addHours(fromHours, fromMinutes, 24, 0);
                addHours(0, 0, toHours, toMinutes);
            } else {
                addHours(fromHours, fromMinutes, toHours, toMinutes);
            }
        }


        return availableHours;
    };




    const getAvailableHours_FALLBACK_VERSION = (reservationFrom, reservationTo, d) => {
        //TODO Remove this fallback version in future versions
        if (!reservationFrom || !reservationTo) {
           return [];
        }
        const intervalMinutes = 15;
        const availableHours = [];
        const reservationFromHM = reservationFrom.split(":");
        let fromHours = parseInt(reservationFromHM[0]);
        let fromMinutes = parseInt(reservationFromHM[1]);
        const fromDate = new Date(d.getTime());
        fromDate.setHours(fromHours);
        fromDate.setMinutes(fromMinutes);

        const reservationToHM = reservationTo.split(":");
        let toHours = parseInt(reservationToHM[0]);
        let toMinutes = parseInt(reservationToHM[1]);
        const toDate = new Date(d.getTime());
        toDate.setHours(toHours);
        toDate.setMinutes(toMinutes);

        const dHours = d.getHours();
        const dMinutes = d.getMinutes();

        function addHours(fromHours, fromMinutes, toHours, toMinutes) {
            let hours = fromHours;
            let minutes = fromMinutes;
            let currentMinutes = (Math.floor(minutes / intervalMinutes)) * intervalMinutes;
            if (currentMinutes < minutes) {
                currentMinutes = currentMinutes + intervalMinutes;
                if (currentMinutes >= 60) {
                    currentMinutes = currentMinutes - 60;
                    hours = hours + 1;
                }
            }

            if (currentMinutes === 60) {
                currentMinutes =0;
                hours+=1;
            }
            while (hours < toHours || (hours == toHours && currentMinutes < toMinutes)) {
                const realToHours = hours % 24;
                availableHours.push((realToHours < 10 ? "0" + realToHours : realToHours) + ":" + (currentMinutes < 10 ? "0" + currentMinutes : currentMinutes));
                currentMinutes = currentMinutes + intervalMinutes;

                if (currentMinutes >= 60) {
                    currentMinutes = currentMinutes - 60;

                    hours = hours + 1;
                }
            }
        }

        function isToday() {
            const now = new Date();
            return d.getUTCFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate();
        }

        if (toHours < fromHours || (toHours == fromHours && toMinutes <= fromMinutes)) {
            // 00:00 -> toHours  and fromHours -> 24:00
            if (dHours < toHours || (dHours == toHours && dMinutes < toMinutes)) {
                addHours(dHours, isToday() ? (dMinutes + intervalMinutes) : dMinutes, toHours, toMinutes);
                addHours(fromHours, fromMinutes, 24, 0);
            } else if (dHours < fromHours || (dHours == fromHours && dMinutes < fromMinutes)) {
                addHours(fromHours, fromMinutes, 24, 0);
            } else {
                addHours(dHours, isToday() ? (dMinutes + intervalMinutes) : dMinutes, 24, 0);
            }
        } else {
            // fromHours -> toHours
            if (dHours > fromHours || (dHours == fromHours && dMinutes >= fromMinutes) &&
                dHours < toHours || (dHours == toHours && dMinutes < toMinutes)
            ) {
                addHours(dHours, isToday() ? (dMinutes + intervalMinutes) : dMinutes, toHours, toMinutes);
            } else if (dHours < fromHours || (dHours == fromHours && dMinutes < fromMinutes)) {
                addHours(fromHours, fromMinutes, toHours, toMinutes);
            }
        }

        return availableHours;
    }



    const getUnavailableDatesForYear = (year) => {
        const unavailableDates = [];
        const startDate = new Date(year, 0, 1);
        const endDate = new Date(year, 11, 31);


        for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
            const currentDate = new Date(d);
            const dayIndex = (currentDate.getDay() === 0 ? 6 : currentDate.getDay() - 1);
            const schedule = weekReservationSchedule[dayIndex];

            if (!schedule || !schedule.isOpen) {
                unavailableDates.push(currentDate.toISOString().split("T")[0]);
                continue;
            }

            const daySchedule = schedule.daySchedule?.[0];
            if (!daySchedule) {
                unavailableDates.push(currentDate.toISOString().split("T")[0]);
                continue;
            }

            const [openHour, openMinute] = daySchedule.openFrom.split(":").map(Number);
            const [closeHour, closeMinute] = daySchedule.openUntil.split(":").map(Number);

            const openFromMinutes = openHour * 60 + openMinute;
            const openUntilMinutes = closeHour * 60 + closeMinute;

            if (openUntilMinutes === 0 || openFromMinutes >= openUntilMinutes) {
                if (openHour !== closeHour) {
                    if (openHour < closeHour) {
                        //daca trece in ziua urmatoare, de ex 00:00 - 10:00
                        unavailableDates.push(currentDate.toISOString().split("T")[0]);
                    }
                }
            }
        }
        return unavailableDates;
    };



    const getNextAvailableDate = () => {
        if (weekReservationSchedule === null) {
            return;
        }
        const today = new Date();
        const todayIndex = today.getDay() === 0 ? 6 : today.getDay() - 1;
        const nowMinutes = today.getHours() * 60 + today.getMinutes();

        for (let i = 0; i < 7; i++) {
            const index = (todayIndex + i) % 7;
            const schedule = weekReservationSchedule[index];

            if (schedule?.isOpen) {
                const daySchedule = schedule.daySchedule[0];

                const openFromHM = daySchedule.openFrom.split(":");
                const openFromMinutes = parseInt(openFromHM[0]) * 60 + parseInt(openFromHM[1]);
                const openUntilHM = daySchedule.openUntil.split(":");
                const openUntilMinutes = parseInt(openUntilHM[0]) * 60 + parseInt(openUntilHM[1]);


                if (i === 0 && nowMinutes < openFromMinutes) {
                    const availableDate = new Date(today);
                    availableDate.setHours(parseInt(openFromHM[0]), parseInt(openFromHM[1]));
                    return {
                        date: availableDate,
                        hours: [`${openFromHM[0]}:${openFromHM[1]}`]
                    };
                }

                if (nowMinutes >= openFromMinutes && nowMinutes < openUntilMinutes) {
                    return {
                        date: today,
                        hours: getAvailableHoursForReservation(today)
                    };
                }
                if (i > 0) {
                    const futureDate = new Date(today);
                    futureDate.setDate(today.getDate() + i);
                    return {
                        date: resetTime(futureDate),
                        hours: getAvailableHoursForReservation(futureDate)
                    };
                }
            }
        }
        return { date: null, hours: [] };
    };


    const nextAvailable = getNextAvailableDate();
    let firstAvailableDate;
    if (nextAvailable) {
        firstAvailableDate = nextAvailable.date;

    }else{
        firstAvailableDate = null;
    }





    let availableHoursForToday;
    if (weekReservationSchedule !== null) {
        availableHoursForToday = todayReservationSchedule?.isOpen
            ? getAvailableHoursForReservation(today)
            : [];
    }else{
        availableHoursForToday = getAvailableHours_FALLBACK_VERSION(shopDetails?.merchantConfig?.reservationFrom, shopDetails?.merchantConfig?.reservationTo, today);
    }



    const availableHoursForTomorrow = tomorrowReservationSchedule?.isOpen
        ? getAvailableHoursForReservation(tomorrow)
        : [];


    let initialSelectedDate;

    if (weekReservationSchedule !== null) {
        initialSelectedDate = availableHoursForToday.length > 0
            ? today
            : (availableHoursForTomorrow.length > 0 ? tomorrow : firstAvailableDate);
    }else{
        initialSelectedDate = today;
    }


    const [state, setState] = useState({
        loading: false,
        errorMsg: null,
        isSubmitBtnEnabled: true,
        shopDetails: shopDetails,
        guestsNr: null,
        calendarIsVisible: false,
        selectedDate: initialSelectedDate,
        pickedHour: null,
        otherRequests: null,
        contactName: null,
        phoneNumber:  null,
    });



    useEffect(() => {
        const handlePopstate = () => {
            if (window.history.state && window.history.state.action === 'POP') {
                if (!hasBackButton || hasReservations) {
                    navigateTo({
                        pathname:PATH.ALL_RESERVATIONS,
                        replace:true
                    });
                } else {
                    navigateTo({
                        pathname:PATH.MAIN,
                        replace:true
                    });
                }
            }
        };

        window.addEventListener('popstate', handlePopstate);

        return () => {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, [navigateTo]);

    useEffect(() => {
        if (reservationInfo && userInfo) {


            setState({
                ...state,
                guestsNr: reservationInfo.guestsNr,
                selectedDate: new Date(reservationInfo.selectedDate),
                pickedHour: reservationInfo.pickedHour,
                otherRequests: reservationInfo.otherRequests,
                contactName: reservationInfo.contactName,
                phoneNumber: userInfo.phone,
            })

        }else if (userInfo) {
            setState({
                ...state,
                phoneNumber: userInfo.phone,
            })
        }


    }, []);



    analyticsLogEvent("screen_view", {
        firebase_screen: FIREBASE_SCREEN_NAMES.CREATE_RESERVATION,
        firebase_screen_class: FIREBASE_SCREEN_NAMES.CREATE_RESERVATION
    });


    const handleSubmit = () => {
        createReservation();
    }

    const validateInputs = () => {
        if (state.pickedHour === null) {
            return <FormattedMessage id="PleaseSelectTheHour"/>;
        } else if (state.guestsNr === null) {
            return <FormattedMessage id="PleaseSelectTheNumberOfGuests"/>

        } else if (state.contactName === null || state.contactName === "" || !state.contactName.replace(/\s/g, '').length) {
            return <FormattedMessage id="PleaseFillTheNameField"/>;
        } else if (state.phoneNumber === null || state.phoneNumber === "" || !state.phoneNumber.replace(/\s/g, '').length) {
            return <FormattedMessage id="PleaseFillThePhoneField"/>;
        } else if (!/^\+?[0-9-]{3,}$/.test(state.phoneNumber)) {
            return <FormattedMessage id="Error.incorrectPhoneFormat"/>;
        } else return null;
    }


    const createReservation = async () => {
        const error = validateInputs();
        if (error) {
            setState({
                ...state,
                errorMsg: error
            })
            return;
        }



        if (!error && !state.phoneNumber) {
            saveInfoAndGoToUpdatePhone();
            return;
        }

        if (!state.isSubmitBtnEnabled) {
            return;
        }
        setState({
            ...state,
            isSubmitBtnEnabled: false,
            loading: true,
        })


        const sentDate = new Date(state.selectedDate.getTime());
        const reservationToHM = state.pickedHour?.split(":");

        sentDate.setHours(parseInt(reservationToHM[0]));
        sentDate.setMinutes(parseInt(reservationToHM[1]));
        sentDate.setSeconds(0);
        sentDate.setMilliseconds(0);

        const body = {
            "shop": StorageService.getItem(LOCALSTORAGE_ITEMS.SHOP_NAME),
            "user": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            "date": sentDate,
            "name": state.contactName,
            "guestsNr": state.guestsNr,
            "request": state.otherRequests,
            "contact": state.phoneNumber
        }

        const response = await ReservationService.createReservation(body);

        if (response.ok) {
            setState({
                ...state,
                isSubmitBtnEnabled: true,
                errorMsg: null,
                loading: false,
            })
            StorageService.removeItem(LOCALSTORAGE_ITEMS.RESERVATION_INFO);
            navigateTo(PATH.ALL_RESERVATIONS);
        }else if (response.data.error?.indexOf("reservation not available") > 0 ) {
            setState({
                ...state,
                errorMsg: <FormattedMessage id="Error.reservationNotAvailableAtTheMoment"/>,
                loading: false,
            })
        } else {

            setState({
                ...state,
                errorMsg: <FormattedMessage id="Error.genericError"/>,
                loading: false,
            })
        }
    }

    const goBack = () => {
        if (!hasBackButton || hasReservations) {
            navigateTo(PATH.ALL_RESERVATIONS);
        } else {
            navigateTo(PATH.MAIN);
        }

    }

    const handleOtherRequestsInput = (value) => {
        setState({
            ...state,
            otherRequests: value
        })
    }
    const handleNameInput = (value) => {
        setState({
            ...state,
            contactName: value
        });
    }


    const handleGuestNumberChange = (value) => {
        setState({
            ...state,
            guestsNr: value
        })
    }

    const handlePickedHour = (value) => {
        setState({
            ...state,
            pickedHour: value
        })
    }



    const handleDateChange = (selectedDay) => {
        if (selectedDay === DAY.TODAY) {
            setState({
                ...state,
                calendarIsVisible: false,
                selectedDate: today,
            })


        } else if (selectedDay === DAY.TOMORROW) {
            setState({
                ...state,
                calendarIsVisible: false,
                selectedDate: tomorrow
            })

        } else if (selectedDay === DAY.MORE_DATES) {
            setState({
                ...state,
                calendarIsVisible: true
            })
            document.body.classList.add("blocked");
        }
    }

    const closeCalendar = () => {
        setState({
            ...state,
            calendarIsVisible: false
        })
        document.body.classList.remove("blocked");
    }

    const handleCalendarPick = (e) => {
        setState({
            ...state,
            selectedDate: e,
        })
    }

    const getMaxNrOfPeople = (maxNr) => {
        const nrofPeople = [];
        for (var i = 1; i <= maxNr; i++) {
            nrofPeople.push(i);
        }
        return nrofPeople;
    }




    const toSchedulesPage = () => {
        navigateTo(PATH.SCHEDULES);
    }

    const saveInfoAndGoToUpdatePhone = () => {
        const reservationInfo = {
            contactName: state.contactName,
            guestsNr: state.guestsNr,
            selectedDate: state.selectedDate,
            pickedHour: state.pickedHour,
            otherRequests: state.otherRequests,
            shopDetails: state.shopDetails
        }
        StorageService.setItem(LOCALSTORAGE_ITEMS.RESERVATION_INFO, JSON.stringify(reservationInfo));
        navigateTo({
            pathname: PATH.PROFILE_UPDATE_PHONE,
            search: "?countdown=true"
        });
    }

    const tileDisabled = ({ date, view }) => {
        if (view !== "month") return false;
        const year = date.getFullYear();
        const dates = getUnavailableDatesForYear(year);
        const dateString = date.toISOString().split("T")[0];
        return dates.includes(dateString);
    };

    if (reservationEnabled) {
        return (
            <>
                <CookiesBanner/>
                {state.shopDetails?.merchantConfig &&
                    <div className="inner-content">
                        <header className="common-header no-bg">

                            {(hasBackButton || hasReservations) &&
                                <a className="btn-back" onClick={() => goBack()}><img alt="back icon" src={backImg}/></a>}
                            <a className="btn-schedules right-aligned" onClick={() => toSchedulesPage()}
                               data-qa="reservation-show-schedules-btn"><img alt="back" src={iconSchedule}/></a>
                            {state.shopDetails?.title && <h2 className="row title">{state.shopDetails?.title}</h2>}
                            {state.shopDetails?.data.address &&
                                <div className="row address"><img alt="location icon"
                                                                  src={iconLocation}/>{state.shopDetails?.data.address}
                                </div>}
                            {state.shopDetails?.data.phone &&
                                <div className="row phone"><img alt="phone icon" src={iconPhone}/>{state.shopDetails?.data.phone}
                                </div>}
                        </header>





                        <ElementPicker
                            typeOfPicker={ELEMENT_PICKER_TYPES.NUMBER_OF_PEOPLE_PICKER}
                            extraClassName={"select-nr-of-people-picker"}
                            allElements={getMaxNrOfPeople(state.shopDetails?.merchantConfig.reservationGuestsMax)}
                            title={<FormattedMessage id="SelectNumberOfPeople"/>}
                            handleGuestNumberChange={handleGuestNumberChange}
                            defaultPicked={state.guestsNr}
                            dataQAIdentifier={"reservation-select-nr-people"}
                        />
                        <section className="all-elements-list reservation-date-picker">
                            <div className="row title">
                                <p>{<FormattedMessage id="SelectDateAndTime"/>}</p>
                            </div>

                            {weekReservationSchedule !== null ?

                                <div className="row element-picker">
                                    <div ref={todayRef} id={DAY.TODAY} onClick={()  => ( availableHoursForToday.length > 0) && handleDateChange(DAY.TODAY)}
                                         className={
                                             new Date(state.selectedDate).toLocaleDateString() === today.toLocaleDateString()
                                                 ? "element big-size active"
                                                 : (availableHoursForToday.length === 0 ? "element big-size disabled" : "element big-size")
                                         } data-qa="reservation-date-select-today">{
                                        <FormattedMessage id="Today"/>}</div>
                                    <div ref={tomorrowRef} id={DAY.TOMORROW} onClick={() => handleDateChange(DAY.TOMORROW)}
                                         className={
                                             new Date(state.selectedDate).toLocaleDateString() === tomorrow.toLocaleDateString()
                                                 ? "element big-size active"
                                                 : (availableHoursForTomorrow.length === 0 ? "element big-size disabled" : "element big-size")
                                         }
                                         data-qa="reservation-date-select-tomorrow">{
                                        <FormattedMessage
                                            id="Tomorrow"/>}</div>
                                    <div ref={moreDatesRef} id={DAY.MORE_DATES} onClick={() => handleDateChange(DAY.MORE_DATES)}
                                         className={(new Date(state.selectedDate).getDate() !== today.getDate() && new Date(state.selectedDate).getDate() !== tomorrow.getDate()) ? "element big-size active" : "element big-size"} data-qa="reservation-date-select-more-dates">
                                        {resetTime(new Date(state.selectedDate.getTime())).getTime() === resetTime(new Date()).getTime() ||
                                        resetTime(new Date(state.selectedDate.getTime())).getTime() === tomorrow.getTime() ?
                                            <FormattedMessage id="MoreDates"/> : <Moment
                                                format={DATE_FORMAT.DAY_MONTH_YEAR_MOBILE_VERSION}
                                                date={state.selectedDate}
                                            />
                                        }
                                    </div>
                                </div>
                                :
                                <div className="row element-picker">
                                    <div ref={todayRef} id={DAY.TODAY} onClick={()  => ( availableHoursForToday.length > 0) && handleDateChange(DAY.TODAY)}
                                         className={new Date(state.selectedDate).getDate() === today.getDate() ? "element big-size active" : (availableHoursForToday.length === 0 ? "element big-size disabled" : "element big-size")} data-qa="reservation-date-select-today">{
                                        <FormattedMessage id="Today"/>}</div>
                                    <div ref={tomorrowRef} id={DAY.TOMORROW} onClick={() => handleDateChange(DAY.TOMORROW)}
                                         className={new Date(state.selectedDate).getDate() === tomorrow.getDate() ? "element big-size active" : "element big-size"} data-qa="reservation-date-select-tomorrow">{<FormattedMessage
                                        id="Tomorrow"/>}</div>
                                    <div ref={moreDatesRef} id={DAY.MORE_DATES} onClick={() => handleDateChange(DAY.MORE_DATES)}
                                         className={(new Date(state.selectedDate).getDate() !== today.getDate() && new Date(state.selectedDate).getDate() !== tomorrow.getDate()) ? "element big-size active" : "element big-size"} data-qa="reservation-date-select-more-dates">
                                        {resetTime(new Date(state.selectedDate.getTime())).getTime() === resetTime(new Date()).getTime() ||
                                        resetTime(new Date(state.selectedDate.getTime())).getTime() === tomorrow.getTime() ?
                                            <FormattedMessage id="MoreDates"/> : <Moment
                                                format={DATE_FORMAT.DAY_MONTH_YEAR_MOBILE_VERSION}
                                                date={state.selectedDate}
                                            />
                                        }
                                    </div>
                                </div>


                            }

                        </section>

                        {weekReservationSchedule !== null?
                            <ElementPicker
                                typeOfPicker={ELEMENT_PICKER_TYPES.HOUR_PICKER}
                                extraClassName={"select-hour-picker"}
                                allElements={getAvailableHoursForReservation(state.selectedDate)}
                                handlePickedHour={handlePickedHour}
                                defaultPicked={state.pickedHour}
                                dataQAIdentifier={"reservation-select-hour"}
                            />
                            :
                            <ElementPicker
                                typeOfPicker={ELEMENT_PICKER_TYPES.HOUR_PICKER}
                                extraClassName={"select-hour-picker"}
                                allElements={getAvailableHours_FALLBACK_VERSION(state.shopDetails?.merchantConfig.reservationFrom, state.shopDetails?.merchantConfig.reservationTo, state.selectedDate)}
                                handlePickedHour={handlePickedHour}
                                defaultPicked={state.pickedHour}
                                dataQAIdentifier={"reservation-select-hour"}
                            />

                        }


                        <section className="requests-form">
                            <div className="row title">
                                <p>{<FormattedMessage id="OtherRequests"/>}</p>
                            </div>
                            <div className="row">
                                <input
                                    type="text"
                                    defaultValue={state.otherRequests}
                                    onChange={e => handleOtherRequestsInput(e.target.value)}
                                    maxLength={150}
                                    autoComplete="off"
                                    data-qa="reservation-other-requests-input"
                                />
                            </div>
                        </section>

                        <section className="reservation-contact">
                            <div className="row title">
                                <p>{<FormattedMessage id="ReservationContact"/>}</p>
                            </div>

                            <div className="form-group">
                                <div className="row">
                                    <label>{<FormattedMessage id="Name"/>}</label>
                                    <input
                                        type="text"
                                        defaultValue={state.contactName}
                                        onChange={e => handleNameInput(e.target.value)}
                                        maxLength={150}
                                        autoComplete="off"
                                        data-qa="reservation-other-name-input"
                                    />
                                </div>

                                <div className="row">
                                    <label>{<FormattedMessage id="PhoneNo"/>}</label>
                                    <input
                                        type="tel"
                                        defaultValue={state.phoneNumber}
                                        onFocus={() => saveInfoAndGoToUpdatePhone()}
                                        maxLength={15}
                                        onClick={() => saveInfoAndGoToUpdatePhone()}
                                        pattern={"/\+?([0-9]+(-|\s)?)+/g"}
                                        autoComplete="off"
                                        data-qa="reservation-phone-input"
                                    />
                                </div>
                            </div>
                        </section>

                        {state.errorMsg != null ?
                            <div className="error-div">
                                <p>&#9888;&nbsp;{state.errorMsg}</p>
                            </div>
                            : null
                        }
                    </div>
                }

                <ReservationActionsBar
                    buttonName={<FormattedMessage id="SendRequest"/>}
                    btnClassName={"btn btn-default btn-xl"}
                    buttonAction={() => handleSubmit()}
                />


                {state.calendarIsVisible &&
                    <>
                        <div onClick={closeCalendar}
                             className={!state.calendarIsVisible ? "blurry-background hidden" : "blurry-background"}>
                        </div>

                        <button data-qa="close-calendar-btn" onClick={closeCalendar}
                                className="pick-calendar-date-btn btn btn-md btn-default">{<FormattedMessage id="Select"/>}

                        </button>

                        <Calendar
                            onChange={handleCalendarPick}
                            tileDisabled={weekReservationSchedule !== null ? tileDisabled:null}
                            minDate={today}
                            maxDate={nextYear}
                            showNavigation={true}
                            locale={getAppLocale()}
                            className={"custom-calendar"}
                        />
                    </>
                }
                {state.loading ?
                    <div className="spinner" data-qa="spinner"><Spinner/></div>
                    : null
                }
            </>
        );
    }else{
        return (
            <>
                <CookiesBanner/>
                {state.shopDetails?.merchantConfig &&
                    <div className="inner-content">
                        <header className="common-header no-bg">
                            <div className="error-div ">
                                <p>&#9888;&nbsp;Reservations module is disabled for {state.shopDetails?.title}</p>
                            </div>
                        </header>

                    </div>
                        }
            </>
        )
    }

}

export default CreateReservation;
